// src/components/shared/ConfirmModal.jsx
import React from "react";

export default function ConfirmModal({
  visible,
  onClose,
  onConfirm,
  mensaje,
  title = "¿Confirmar acción?",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  danger = true,
  closeOnBackdrop = true,
}) {
  if (!visible) return null;

  const onBackdrop = (e) => {
    if (!closeOnBackdrop) return;
    if (e.target === e.currentTarget) onClose?.();
  };

  const handleConfirm = async (e) => {
    e?.preventDefault?.();
    try {
      await onConfirm?.();
    } catch (err) {
      console.error("ConfirmModal error:", err);
    } finally {
      onClose?.();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/40 backdrop-blur-sm"
      onMouseDown={onBackdrop}
      role="dialog" aria-modal="true"
    >
      <div
        className="w-full max-w-sm sm:max-w-md rounded-2xl bg-white p-6 shadow-2xl"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-bold text-gray-800 text-center">{title}</h2>
        <p className="mt-2 text-sm text-gray-600 text-center">{mensaje}</p>

        <div className="mt-5 flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-xl text-sm font-medium text-gray-700 bg-gray-200 hover:bg-gray-300"
          >
            {cancelText}
          </button>

          <button
            type="button"
            onClick={handleConfirm}
            className={[
              "px-4 py-2 rounded-xl text-sm font-medium text-white",
              danger ? "bg-red-600 hover:bg-red-700" : "bg-indigo-600 hover:bg-indigo-700",
            ].join(" ")}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}